const blogDrag = function () {
  var dragContainers = document.querySelectorAll("[data-drag-scroll]");
  if (!dragContainers.length) {
    return;
  }

  dragContainers.forEach(function (container) {
    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;
    var activePointer = null;
    var hasMoved = false;
    var clickedLink = null;

    container.addEventListener(
      "wheel",
      function (event) {
        if (event.cancelable) {
          event.preventDefault();
        }
      },
      { passive: false }
    );

    container.style.touchAction = "none";

    var startDrag = function (event) {
      if (event.pointerType === "mouse" && event.button !== 0) {
        return;
      }

      clickedLink = event.target.closest("a");
      if (clickedLink && event.pointerType === "mouse") {
        event.preventDefault();
      }

      activePointer = event.pointerId;
      isDragging = true;
      hasMoved = false;
      startX = event.pageX;
      scrollStart = container.scrollLeft;
      container.classList.add("is-dragging");
      container.setPointerCapture(activePointer);
    };

    var moveDrag = function (event) {
      if (!isDragging || event.pointerId !== activePointer) {
        return;
      }
      if (event.cancelable) {
        event.preventDefault();
      }

      var delta = event.pageX - startX;
      if (Math.abs(delta) > 3) {
        hasMoved = true;
      }

      container.scrollLeft = scrollStart - delta;
    };

    var endDrag = function (event) {
      if (!isDragging || (event && event.pointerId !== activePointer)) {
        return;
      }
      isDragging = false;
      container.classList.remove("is-dragging");

      if (typeof activePointer === "number") {
        container.releasePointerCapture(activePointer);
      }
      activePointer = null;

      if (!hasMoved && clickedLink) {
        clickedLink.click();
      }

      clickedLink = null;
    };

    container.addEventListener("pointerdown", startDrag);
    container.addEventListener("pointermove", moveDrag, { passive: false });
    container.addEventListener("pointerup", endDrag);
    container.addEventListener("pointercancel", endDrag);
  });
};

blogDrag();

const blogSearch = function () {
  const DEBOUNCE_MS = 220;
  const CLOSE_ANIMATION_MS = 180;
  const MIN_QUERY_LENGTH = 2;
  const RESULTS_LIMIT = 5;

  const toolbars = document.querySelectorAll("[data-blog-filter-toolbar]");
  if (!toolbars.length) {
    return;
  }

  toolbars.forEach((toolbar) => {
    const form = toolbar.querySelector("[data-blog-search-form]");
    const submitBtn = toolbar.querySelector("[data-blog-search-submit]");
    const input = toolbar.querySelector("[data-blog-search-input]");
    const predictiveResults = toolbar.querySelector(
      "[data-blog-predictive-results]"
    );

    if (!form || !input) {
      return;
    }

    let controller = null;
    let debounceTimer = null;
    let hideTimer = null;
    let activeIndex = -1;
    const cache = new Map();

    const closePredictive = () => {
      if (!predictiveResults) {
        return;
      }
      activeIndex = -1;
      input.setAttribute("aria-expanded", "false");
      predictiveResults.classList.remove("is-visible");
      if (hideTimer) {
        clearTimeout(hideTimer);
      }
      hideTimer = setTimeout(() => {
        predictiveResults.hidden = true;
        predictiveResults.textContent = "";
      }, CLOSE_ANIMATION_MS);
    };

    const openPredictive = () => {
      if (!predictiveResults) {
        return;
      }
      if (hideTimer) {
        clearTimeout(hideTimer);
      }
      activeIndex = -1;
      input.setAttribute("aria-expanded", "true");
      predictiveResults.hidden = false;
      requestAnimationFrame(() => {
        predictiveResults.classList.add("is-visible");
      });
    };

    const getNavigableItems = () => {
      if (!predictiveResults) {
        return [];
      }
      return predictiveResults.querySelectorAll(
        ".blog-predictive-all, .blog-predictive-link"
      );
    };

    const updateActiveDescendant = () => {
      const items = getNavigableItems();
      items.forEach((item, i) => {
        const isActive = i === activeIndex;
        item.classList.toggle("is-selected", isActive);
        item.id = isActive ? "predictive-active-item" : "";
      });
      input.setAttribute(
        "aria-activedescendant",
        activeIndex >= 0 ? "predictive-active-item" : ""
      );
    };

    const createEl = (tag, attrs, text) => {
      const el = document.createElement(tag);
      if (attrs) {
        for (const key in attrs) {
          el.setAttribute(key, attrs[key]);
        }
      }
      if (text) {
        el.textContent = text;
      }
      return el;
    };

    const renderPredictiveItems = (articles, query) => {
      if (!predictiveResults) {
        return;
      }
      predictiveResults.textContent = "";

      if (!articles || !articles.length) {
        const empty = createEl(
          "p",
          {
            class: "blog-predictive-empty",
            role: "status",
          },
          "Keine Ergebnisse gefunden"
        );
        predictiveResults.appendChild(empty);
        openPredictive();
        return;
      }

      const allLink = createEl(
        "a",
        {
          class: "blog-predictive-all",
          href: "/search?type=article&q=" + encodeURIComponent(query),
          role: "option",
        },
        "Alle Ergebnisse anzeigen"
      );
      predictiveResults.appendChild(allLink);

      const list = createEl("ul", {
        class: "blog-predictive-list",
        role: "listbox",
      });

      articles.forEach((item) => {
        const li = createEl("li", {
          class: "blog-predictive-item",
          role: "presentation",
        });
        const link = createEl(
          "a",
          {
            class: "blog-predictive-link",
            href: item.url,
            role: "option",
          },
          item.title
        );
        li.appendChild(link);
        list.appendChild(li);
      });

      predictiveResults.appendChild(list);
      openPredictive();
    };

    const fetchPredictive = async (query) => {
      if (!predictiveResults) {
        return;
      }

      const cached = cache.get(query);
      if (cached) {
        renderPredictiveItems(cached, query);
        return;
      }

      if (controller) {
        controller.abort();
      }
      controller = new AbortController();

      const endpoint =
        "/search/suggest.json?q=" +
        encodeURIComponent(query) +
        "&resources[type]=article&resources[limit]=" +
        RESULTS_LIMIT;

      try {
        const response = await fetch(endpoint, { signal: controller.signal });
        if (!response.ok) {
          renderPredictiveItems([], query);
          return;
        }
        const data = await response.json();
        const articles =
          data && data.resources && data.resources.results
            ? data.resources.results.articles || []
            : [];

        cache.set(query, articles);
        renderPredictiveItems(articles, query);
      } catch (error) {
        if (error && error.name === "AbortError") {
          return;
        }
        closePredictive();
      }
    };

    input.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closePredictive();
        input.blur();
        return;
      }

      if (event.key === "Enter") {
        const items = getNavigableItems();
        if (activeIndex >= 0 && items[activeIndex]) {
          event.preventDefault();
          items[activeIndex].click();
          return;
        }
      }

      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        const items = getNavigableItems();
        if (!items.length) {
          return;
        }
        event.preventDefault();
        if (event.key === "ArrowDown") {
          activeIndex = activeIndex < items.length - 1 ? activeIndex + 1 : 0;
        } else {
          activeIndex = activeIndex > 0 ? activeIndex - 1 : items.length - 1;
        }
        updateActiveDescendant();
      }
    });

    input.addEventListener("input", () => {
      const query = input.value.trim();
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      if (query.length < MIN_QUERY_LENGTH) {
        closePredictive();
        return;
      }
      debounceTimer = setTimeout(() => {
        fetchPredictive(query);
      }, DEBOUNCE_MS);
    });

    if (submitBtn) {
      submitBtn.addEventListener("click", (event) => {
        const items = getNavigableItems();
        if (activeIndex >= 0 && items[activeIndex]) {
          event.preventDefault();
          items[activeIndex].click();
          return;
        }
        if (input.value.trim() === "") {
          event.preventDefault();
          input.focus();
        }
      });
    }

    form.addEventListener("submit", (event) => {
      if (input.value.trim() === "") {
        event.preventDefault();
      }
    });

    if (predictiveResults) {
      predictiveResults.addEventListener("mouseover", (event) => {
        const link = event.target.closest(
          ".blog-predictive-all, .blog-predictive-link"
        );
        if (!link) {
          return;
        }
        const items = getNavigableItems();
        activeIndex = Array.from(items).indexOf(link);
        updateActiveDescendant();
      });

      predictiveResults.addEventListener("mouseleave", () => {
        activeIndex = -1;
        updateActiveDescendant();
      });
    }

    document.addEventListener("click", (event) => {
      if (!toolbar.contains(event.target)) {
        closePredictive();
      }
    });
  });
};

blogSearch();
